import React from 'react';
import PropTypes from 'prop-types';

import { Container } from 'components/atoms/Page';
import { H2 } from 'components/core/Typography';
import { Link } from 'components/core/Link';
import './UnitList.scss';
import { UnitCard } from 'components/molecules';
import ScrollWrapper from 'components/molecules/ScrollWrapper/ScrollWrapper';

export default function UnitList(props) {
	const {
		unitsData,
		scrollFactor,
		slug,
		sectionHeader,
		headerLinkText,
		headerLink,
	} = props;

	return (
		<div className="psp-units-list-layout">
			{sectionHeader && (
			<Container>
				<div className="psp-units-list-header">
					<H2
						size="large"
						weight="bold"
					>
						{sectionHeader}
					</H2>
					<Link href={headerLink}>{headerLinkText}</Link>
				</div>
			</Container>
			)}
			<div className={`psp-units-list-container ${slug}`}>
				<ScrollWrapper
					className={`psp-units-list-scroll-wrapper ${slug}`}
				>
					{unitsData.map((unitInfo) => {
						return (
							<UnitCard
								key={unitInfo.title}
								{...unitInfo}
							/>
						);
					})}
				</ScrollWrapper>
			</div>
		</div>
	);
}

UnitList.propTypes = {
	unitsData: PropTypes.arrayOf(PropTypes.object).isRequired,
	scrollFactor: PropTypes.number.isRequired,
	slug: PropTypes.string.isRequired,
	sectionHeader: PropTypes.string.isRequired,
	headerLinkText: PropTypes.string.isRequired,
	headerLink: PropTypes.string.isRequired,
};
